import { render, staticRenderFns } from "./MaxLengthTextarea.vue?vue&type=template&id=5bebd21e&scoped=true"
import script from "./MaxLengthTextarea.vue?vue&type=script&lang=js"
export * from "./MaxLengthTextarea.vue?vue&type=script&lang=js"
import style0 from "./MaxLengthTextarea.vue?vue&type=style&index=0&id=5bebd21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebd21e",
  null
  
)

export default component.exports